export const filterByNumericPhone = (rowVal: string | null, phone: number) => {
  if (!rowVal) return false
  const numericPhone = rowVal.toString().replace(/\D/g, '')
  const numericFilter = phone.toString().replace(/\D/g, '')
  return `${numericPhone}`.includes(`${numericFilter}`)
}
